import React, { useEffect, useState } from 'react';
import './StagingBanner.css';

// Shown on Cloudflare Pages preview deployments (*.pages.dev) so reviewers
// immediately understand this URL is a staging copy — NOT the live website.
// Auto-hides on the production domain once DNS is cut over.
// Dismissible per tab (sessionStorage) so it doesn't nag on every route
// change, but reappears on fresh visits as a persistent reminder.

const DISMISS_KEY = 'aen_staging_banner_dismissed';

function isStagingHost() {
  if (typeof window === 'undefined') return false;
  return /\.pages\.dev$/i.test(window.location.hostname);
}

export default function StagingBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isStagingHost()) return;
    const dismissed = sessionStorage.getItem(DISMISS_KEY) === '1';
    if (!dismissed) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div className="staging-banner" role="status" aria-live="polite">
      <span className="sb-tag">BETA</span>
      <span className="sb-msg">
        Team review build — not the live site yet. Share feedback with Peter.
      </span>
      <button
        type="button"
        className="sb-close"
        aria-label="Dismiss staging banner"
        onClick={() => {
          sessionStorage.setItem(DISMISS_KEY, '1');
          setVisible(false);
        }}
      >
        &times;
      </button>
    </div>
  );
}
